import { render, staticRenderFns } from "./ProviderTemplate.vue?vue&type=template&id=050355e9&"
import script from "./ProviderTemplate.vue?vue&type=script&lang=js&"
export * from "./ProviderTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports